import { baseUrl } from '../../config/api';

const AUTH_TOKEN_KEY = 'authToken';

/** Read response body after a non-OK status (single consume of body). */
async function messageFromFailedResponse(res) {
    try {
        const text = await res.text();
        if (!text) {
            return res.statusText || `HTTP ${res.status}`;
        }
        try {
            const data = JSON.parse(text);
            if (data && typeof data.message === 'string') {
                return data.message;
            }
        } catch {
            // not JSON; use raw text below
        }
        return text.length > 500 ? `${text.slice(0, 500)}…` : text;
    } catch {
        return res.statusText || `HTTP ${res.status}`;
    }
}

export const requester = async (method, url, data) => {
    const token = localStorage.getItem(AUTH_TOKEN_KEY);

    const options = {
        method,
        headers: {
            'content-type': 'application/json',
        },
    };

    if (token) {
        options.headers.Authorization = `Bearer ${token}`;
    }

    if (data) {
        options.body = JSON.stringify(data);
    }

    let res;
    try {
        res = await fetch(baseUrl + url, options);
    } catch (err) {
        const msg = err instanceof Error ? err.message : String(err);
        if (err instanceof Error) {
            throw new Error(`Network error for ${method} ${url}: ${msg}`, { cause: err });
        }
        throw new Error(`Network error for ${method} ${url}: ${msg}`);
    }

    if (!res.ok) {
        if (res.status === 401 && token) {
            localStorage.removeItem(AUTH_TOKEN_KEY);
        }
        const detail = await messageFromFailedResponse(res);
        throw new Error(`Request failed (${res.status} ${res.statusText}): ${detail}`);
    }

    if (res.status === 204 || res.status === 205) {
        return null;
    }

    if (res.headers.get('content-length') === '0') {
        return null;
    }

    try {
        return await res.json();
    } catch (err) {
        const msg = err instanceof Error ? err.message : String(err);
        throw new Error(`Invalid JSON in successful response (${res.status}): ${msg}`);
    }
};

export const get = requester.bind({}, 'GET');
export const post = requester.bind({}, 'POST');
export const patch = requester.bind({}, 'PATCH');
export const put = requester.bind({}, 'PUT');
export const del = requester.bind({}, 'DELETE');
